const keys = {
  drivingConvictions: {
    actions: {
      add: 'Add conviction',
      edit: 'Edit',
      remove: 'Remove',
    },
    title: 'Please add every driving conviction for which you were sanctioned except parking tickets.',
    fields: {
      convictionYear: 'Year of the conviction',
      convictionDescription: 'Tell us what happended',
      speedConviction: {
        specificDriver: 'Did {{0}} exceed the speed limit by 50km/hr or more?',
        default: 'Did you exceed the speed limit by 50km/hr or more?',
      },
    },
    placeholders: {
      convictionYear: 'ex. 2019',
      convictionDescription: 'ex. Speed over limit',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
